import React from 'react';
import { X, CheckCircle2, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const Alert = ({
  type = 'info',
  title,
  message,
  onClose,
  className = '',
  showIcon = true,
  children,
}) => {
  const alertConfig = {
    success: {
      icon: CheckCircle2,
      wrap: 'bg-emerald-50 border-emerald-200 text-emerald-900',
      icn: 'text-emerald-600',
    },
    error: {
      icon: AlertCircle,
      wrap: 'bg-rose-50 border-rose-200 text-rose-900',
      icn: 'text-rose-600',
    },
    warning: {
      icon: AlertTriangle,
      wrap: 'bg-amber-50 border-amber-200 text-amber-900',
      icn: 'text-amber-600',
    },
    info: {
      icon: Info,
      wrap: 'bg-brand-50 border-brand-200 text-brand-900',
      icn: 'text-brand-600',
    },
  };

  const config = alertConfig[type] || alertConfig.info;
  const IconComponent = config.icon;

  const wrapperClasses = [
    'flex items-start gap-3 rounded-xl border px-4 py-3',
    config.wrap,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses} role="alert">
      {showIcon && (
        <div className="flex-shrink-0 mt-0.5">
          <IconComponent className={`h-5 w-5 ${config.icn}`} />
        </div>
      )}

      <div className="flex-1 min-w-0 text-sm">
        {title && <p className="font-semibold">{title}</p>}
        {message && (
          <p className={`leading-relaxed ${title ? 'mt-0.5 opacity-90' : ''}`}>
            {message}
          </p>
        )}
        {children}
      </div>

      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 -mr-1 -mt-1 inline-flex items-center justify-center rounded-md p-1.5 opacity-60 hover:opacity-100 hover:bg-white/40 transition"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default Alert;
